import "./loader.css";
import m from "mithril";

let loader = () => {
  return {
    view: (v) => {
      return m("div.loadingHolder", [
        m("div.loadingItem"),
        m("div.loadingItem", {
          style: {
            "animation-delay": ".1s",
          },
        }),
        m("div.loadingItem", {
          style: {
            "animation-delay": ".2s",
          },
        }),
      ]);
    },
  };
};

export default loader;
